module.exports = __webpack_public_path__ + "static/media/smoke.bb9f9069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/starPods/smoke.svg
// module id = 2695
// module chunks = 0